var ReleaseSeatsSegmentsScreen = (function ($) {

    ReleaseSeatsSegmentsScreen = function (options) {
        var that = this;

        options = options || {};

        // CONST
        that.segments_main_data = options['segments_main_data'] || [];
        that.modals = options['modals'] || {};
        that.locales = options['locales'] || {};
        that.order_url = options['order_url'];
        that.class = {
            disabled: 'disabled',
            selected: 'selected',
            hidden: 'hidden',
            error: 'error'
        };
        that.selectors = {
            select_segment: '.js-select-segment',
            select_segment_action_select: '.js-select-segment-action-select',
            available_alert: '.js-available-alert'
        };

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$select_segment = that.$wrapper.find(that.selectors.select_segment);
        that.$select_segment_action_select = that.$wrapper.find(that.selectors.select_segment_action_select);
        that.$available_alert = that.$wrapper.find(that.selectors.available_alert);

        // DYNAMIC VARS
        that.$available_segments = null;

        // HANDLERS
        that.onError = (options['onError'] || false);

        // INIT
        that.init();
    };

    ReleaseSeatsSegmentsScreen.prototype.init = function () {
        var that = this;

        that.__initEvents();
    };

    ReleaseSeatsSegmentsScreen.prototype.isValid = function () {
        var that = this;

        if (!that.$available_segments || that.$available_segments.length === 0) {
            $.uiModal({
                html: this.modals['segments_not_available'],
                onClose: function () {
                    that.onError();
                }
            });
            return false;
        }

        if (that.$select_segment_action_select.filter(':checked').length === 0) {
            that.$available_segments.addClass(that.class.error).siblings('.error').text(that.locales.segment_not_selected);
            return false;
        }

        return true;
    };

    ReleaseSeatsSegmentsScreen.prototype.getData = function () {
        var that = this,
            selected_segment_hashes = [];

        that.$select_segment_action_select.filter(':checked').each(function () {
            selected_segment_hashes.push($(this).parents(that.selectors.select_segment).data('segment-hash'));
        });

        return {
            value: selected_segment_hashes
        };
    };

    ReleaseSeatsSegmentsScreen.prototype.showError = function () {
        var that = this;

        $.uiModal({
            html: that.modals['release_seats_error'],
            esc: false,
            close_on_avia_before_load: false,
            onBgClick: function (modal, event) {
                event.preventDefault();
                return false;
            },
            onClose: function () {
                $.sa.content_router.load(that.order_url);
            }
        });
    };

    /**
     * @private
     */
    ReleaseSeatsSegmentsScreen.prototype.__initEvents = function () {
        var that = this;

        that.$select_segment.on('click', function () {
            var $segment = $(this),
                $input = $segment.find(that.selectors.select_segment_action_select),
                is_checked = !$input.prop('checked');

            if (!$segment.hasClass(that.class.disabled)) {
                $input.prop('checked', is_checked).toggleClass(that.class.selected, is_checked);
                $segment.toggleClass(that.class.selected, is_checked);
            }

            if (that.$select_segment_action_select.filter(':checked').length > 0) {
                that.$select_segment.removeClass(that.class.error);
            }
        });
    };

    // EVENTS

    ReleaseSeatsSegmentsScreen.prototype.beforeUnload = function () {
        var that = this;

        that.$select_segment.addClass(that.class.disabled);
    };

    ReleaseSeatsSegmentsScreen.prototype.afterLoad = function (selected_passenger_hashes = []) {
        var that = this;

        that.$select_segment.removeClass(that.class.disabled);

        if (!selected_passenger_hashes || selected_passenger_hashes.length === 0) {
            that.$select_segment.addClass(that.class.disabled).removeClass(that.class.selected);
            that.$select_segment_action_select.prop('checked', false);
            that.$available_alert.removeClass(that.class.hidden);
            return;
        }

        for (var segment_main_data of that.segments_main_data) {
            that.$select_segment_action_select.each(function () {
                var $select_segment = $(this).parents(that.selectors.select_segment);
                if ($select_segment.data('segment-hash') === segment_main_data['hash']) {
                    $(this).prop('checked', false);

                    var is_available = selected_passenger_hashes.every(element => segment_main_data['available_passenger_hashes'].includes(element));
                    $select_segment.toggleClass(that.class.disabled, !is_available).removeClass(that.class.selected);
                    $select_segment.find(that.selectors.available_alert).toggleClass(that.class.hidden, is_available);
                }
            });
        }

        that.$available_segments = that.$wrapper.find(that.selectors.select_segment).not('.' + that.class.disabled);
        if (that.$available_segments.length === 1) {
            that.$available_segments.addClass(that.class.selected);
            that.$available_segments.find(that.selectors.select_segment_action_select).prop('checked', true);
        }
    };

    return ReleaseSeatsSegmentsScreen;
})($);
